var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('van-overlay',{attrs:{"show":_vm.showOverlay}},[_c('div',{staticClass:"wrapper"},[_c('van-loading',{attrs:{"size":"24px","color":"#ffffff","vertical":""}},[_vm._v("正在授权登陆...")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }